import { render, staticRenderFns } from "./EmailRecipientsEditor.vue?vue&type=template&id=b4c8d932&scoped=true&"
import script from "./EmailRecipientsEditor.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientsEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailRecipientsEditor.vue?vue&type=style&index=0&id=b4c8d932&scoped=true&lang=css&"
import style1 from "./EmailRecipientsEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8d932",
  null
  
)

export default component.exports